module.exports = __webpack_public_path__ + "img/onlineApplyAct.c60422a0.png";